import { type FC } from "react";

import { Button } from "@snapchat/snap-design-system";
import { clsx } from "clsx";

import { ClosableModal, ClosableModalBody, ClosableModalHeader } from "../../shared/components";
import { type ModalProps } from "../../shared/hooks";
import { TextLink } from "../../shared/styles";
import { PHONE_VERIFY_SUPPORT_URL } from "../constants";

import { body, footer, paragraph } from "./PhoneVerificationModal.module.css";
import {
    PhoneVerificationBody,
    PhoneVerificationContinue,
    PhoneVerificationSupportLink,
    PhoneVerificationTitle,
} from "./messages.generated";

interface PhoneVerificationModalProps {
    modalProps: ModalProps;
}

const MODAL_WIDTH = 480;

export const PhoneVerificationModal: FC<PhoneVerificationModalProps> = ({ modalProps }) => (
    <ClosableModal modalProps={modalProps} width={MODAL_WIDTH}>
        <ClosableModalHeader>
            <PhoneVerificationTitle />
        </ClosableModalHeader>
        <ClosableModalBody className={body}>
            <p className={clsx("paragraph-p200", paragraph)}>
                <PhoneVerificationBody
                    supportLink={
                        <TextLink href={PHONE_VERIFY_SUPPORT_URL} target="_blank" rel="noopener noreferrer">
                            <PhoneVerificationSupportLink />
                        </TextLink>
                    }
                />
            </p>
            <div className={footer}>
                <Button type="primary" onClick={modalProps.onCancel} data-testid="phone-verification-continue">
                    <PhoneVerificationContinue />
                </Button>
            </div>
        </ClosableModalBody>
    </ClosableModal>
);
